import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M11.4527 17.5V17.223L10.4369 14.1757L8.12838 7.25H7.57432L5.26577 14.1757L4.25 17.223V17.5M10.4369 14.1757H5.26577" vectorEffect="non-scaling-stroke" />
		<Path d="M14.25 6V15.0386V17.5M14.25 13.2941C14.25 11.2353 15.4265 10.4118 16.8676 10.4118C18.4595 10.4118 19.75 11.6471 19.75 13.7059C19.75 15.7647 18.4595 17 16.8676 17C15.6908 17 14.25 15.7647 14.25 14.1176" vectorEffect="non-scaling-stroke" />
	</SVG>
);
